<template>
    <mt-table-base
        :rows="visibleRows"
        :sort.sync="effectiveSort"
        :emptyMessage="emptyMessage"
        :link="link"
        :page.sync="effectivePage"
        :pageSize="pageSize"
        :paginated="paginated"
        :hideHeaders="hideHeaders"
        :rowClass="rowClass"
        :title="title"
        :loading="loading"
        :highlightedItems="highlightedItems"
        :totalCount="rows.length"
        :keyFunc="keyFunc"
        @update:columns="updateColumns"
        @rowClicked="rowClicked"
    >
        <template #table-head>
            <slot name="table-head" />
        </template>
        <template #preheader>
            <slot name="preheader" />
        </template>
        <template>
            <slot />
        </template>
        <template #empty>
            <slot name="empty" />
        </template>
        <template #table-footer>
            <slot name="table-footer" />
        </template>
    </mt-table-base>
</template>
<script>
export default {
    name: 'MtClientTable',
    provide() {
        return {
            updateSort: this.updateSort,
            currentSort: this.sort,
        }
    },
    props: {
        rows: {
            type: Array,
            default() {
                return []
            },
        },
        defaultSortField: {
            type: String,
            default: '',
        },
        defaultSortDirection: {
            type: String,
            default: 'asc',
        },
        emptyMessage: {
            type: String,
            default: '',
        },
        link: {
            type: Function,
            default: null,
        },
        pageSize: {
            type: Number,
            default: 20,
        },
        paginated: {
            type: Boolean,
            default: false,
        },
        hideHeaders: {
            type: Boolean,
            default: false,
        },
        rowClass: {
            type: Function,
            default: null,
        },
        title: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
        highlightedItems: {
            type: Array,
            default: () => [],
        },
        preservePage: {
            type: Boolean,
            default: false,
        },
        keyFunc: {
            type: Function,
        },
        page: {
            type: Number,
            default: 1,
        },
        sort: {
            type: Object,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            backing: {
                page: 1,
                sort: this.sort ?? {
                    field: this.defaultSortField,
                    direction: this.defaultSortDirection,
                },
            },
            columns: [],
        }
    },
    watch: {
        defaultSortField() {
            this.backing.sort.field = this.defaultSortField
        },
        defaultSortDirection() {
            this.backing.sort.direction = this.defaultSortDirection
        },
        page: {
            handler() {
                this.backing.page = this.page
            },
            immediate: true,
        },
        sort() {
            this.backing.sort = this.sort
        },
        'rows.length'() {
            if (!this.preservePage) {
                this.effectivePage = 1
            } else if (this.rows.length > 0 && this.visibleRows.length == 0) {
                this.effectivePage = Math.floor(this.rows.length / this.pageSize + 1)
            }
        },
    },
    computed: {
        effectivePage: {
            get() {
                return this.backing.page ?? 1
            },
            set(page) {
                page ??= 1
                this.backing.page = page
                this.$emit('update:page', page)
            },
        },
        effectiveSort: {
            get() {
                return this.backing.sort ?? { field: null, direction: null }
            },
            set(sort) {
                sort ??= { field: null, direction: null }
                this.backing.sort = sort
                this.$emit('update:sort', sort)
            },
        },
        sortedRows() {
            const sort = this.effectiveSort
            const field = sort.field
            const direction = sort.direction
            const columns = this.columns
            let rows = this.rows

            if (field) {
                var col = columns.find(c => c?.field == field)

                if (col) {
                    rows = col.applySort(rows.slice(0), direction)
                }
            }

            this.$emit('sorted', rows.slice(0))

            return rows
        },
        visibleRows() {
            var rows = this.sortedRows
            if (this.paginated) {
                return rows.slice((this.effectivePage - 1) * this.pageSize, this.effectivePage * this.pageSize)
            }
            return rows
        },
    },
    methods: {
        rowClicked(row) {
            this.$emit('rowClicked', row)
        },
        updateColumns(columns) {
            this.columns = columns
        },
    },
}
</script>
